<template>
	<el-dialog class='dialog-mobile' title="绑定手机号" :visible.sync="dialogVisible" width="40%">
		<el-form ref="form" :model="formData" label-width="150px" :rules="rules">

			<el-form-item label="请输入帐号密码" prop="password">
				<el-input type="password" v-model="formData.password" placeholder="">
				</el-input>
			</el-form-item>
			<el-form-item label="请输入新的手机号码" prop="mobile">
				<el-input v-model="formData.mobile" placeholder="">
				</el-input>
			</el-form-item>
			<el-form-item label="验证码" prop="imageCaptcha" :rules="[{required: true, message: '请输入验证码'}]">
				<div class="flex flex-row-between">
					<el-input v-model="formData.imageCaptcha" placeholder="输入验证码"></el-input>
					<el-image :src="imageCode" @click="getCaptchaImgHandle" style="width: 120px; height: 38px;cursor: pointer;" fit="fit"></el-image>
				</div>
			</el-form-item>
			<el-form-item label="请输入收到验证码" prop="smsCaptcha" class="code-item">
				<div class="flex flex-row-between">
					<el-input v-model="formData.smsCaptcha" placeholder=""></el-input>
					<el-button type="primary" :disabled="!codeTag" @click="sendHandler">{{codeTag?'获取验证码':second+'s后可重新获取'}}</el-button>
				</div>
			</el-form-item>

		</el-form>
		<span slot="footer" class="dialog-footer">
			<el-button @click="resetHandle">取 消</el-button>
			<el-button type="primary" @click="submitHandle">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { changeMobile, getCaptchaSms, getCaptchaImg } from '@/api';
import { v4 as uuidv4 } from 'uuid';
import BASE_URL from '@/api/base.js'

export default {
	components: {},
	data() {
		return {
			dialogVisible: false,
			formData: {},
			rules: {
				mobile: [
					{ required: true, message: '请输入新的手机号码' },
				],
				password: [
					{ required: true, message: '请输入帐号密码' },
				],
				smsCaptcha: [{ required: true, message: '请输入验证码' }],
			},
			codeTag: true,
			second: 60,
			timer: undefined,
			uuid: undefined,
			imageCode: undefined
		};
	},
	mounted() {
		let uuid = uuidv4();
		this.uuid = uuid;
		this.getCaptchaImgHandle();
	},

	methods: {
		getCaptchaImgHandle() {
			let uuid = uuidv4();
			this.uuid = uuid;
			this.imageCode = BASE_URL + `/api/captcha/image?token=${this.uuid}`
		},
		sendHandler() {
			if (!this.codeTag) {
				return;
			}
			const { mobile, imageCaptcha } = this.formData;
			if (!mobile) {
				return this.$message({
					message: '请输入新的手机号码',
					type: "warning"
				});
			}
			if (!imageCaptcha) {
				return this.$message({
					message: '请输入图形验证码',
					type: "warning"
				});
			}
			this.$set(this, 'codeTag', false)

			getCaptchaSms({ mobile, imageToken: this.uuid, token: this.uuid, imageCaptcha }).then(res => {
				this.$set(this, 'codeTag', false)
				this.timer = setInterval(this.doLoop, 1000);
			}).catch(() => {
				if (this.timer) {
					clearInterval(this.timer);
				}
				this.$set(this, 'codeTag', true);
				this.$set(this, 'second', 60)
			})
		},

		doLoop() {
			this.second--;
			if (this.second === 0) {
				clearInterval(this.timer);
				this.$set(this, 'codeTag', true);
				this.$set(this, 'second', 60)
			}
		},
		show(v) {
			this.$set(this, 'dialogVisible', true)
		},
		resetHandle() {
			this.$refs['form'].resetFields();

			this.$set(this, 'formData', {});
			this.dialogVisible = false;
			if (this.timer) {
				clearInterval(this.timer);
			}
			this.$set(this, 'codeTag', true);
			this.$set(this, 'second', 60)
		},
		submitHandle() {
			this.$refs['form'].validate(val => {
				if (val) {
					const params = Object.assign({}, this.formData, {
						smsToken: this.uuid
					})
					changeMobile(params).then(res => {
						this.$message({
							message: '修改成功',
							type: 'success'
						})
						this.resetHandle();
					})
				}
			})
		}
	},
	computed: {},
	watch: {},
}
</script>
<style lang='scss' >
	.dialog-mobile {
		.el-button {
			width: 120px;
			height: 40px;
			&:hover {
				background-color: $red;
				border-color: $red;
				color: #fff;
			}
		}
		.el-button--primary {
			background-color: $red;
			border-color: $red;
		}
		.check-item {
			.el-form-item__content {
				justify-content: flex-start;
				.link {
					color: $red;
				}
			}
		}
		.el-input {
			width: 230px;
			.el-input__inner {
				width: 280px;
				height: 40px;
				border: 1px solid #efefef !important;
				border-radius: 3px;
			}
		}
		.code-item {
			.el-button {
				margin-left: 15px;
				height: 38px;
				background-color: $red;
				border-color: $red;
			}
		}
	}
</style>
